export default __webpack_public_path__ + "static/media/potions.032820dd.png";